import {
  Step,
  Task,
  LogTimer,
  Notification,
  Trigger,
  TaskForm,
  Template,
} from "./entities";

export class QueryColumns {
  constructor(params, data) {
    this.data = this.make(params, data);
  }

  make(params, { requestSettings, generalSettings }) {
    const all = params.map(({ tasks, ...rest }, stepIndex) => {
      const tasks_built = tasks.data.map((tk) => {
        const map_task = new Task({
          ticket_: tk.attributes.ticket,
          created_at: tk.attributes.created_at,
          updated_at: tk.attributes.updated_at,
          is_request: tk.attributes.is_request,
          master_id: tk.attributes.master_id,
          is_form: tk.attributes.is_form,
          archivers: tk.attributes.archivers,
          started_at: tk.attributes.started_at,
          due_date: tk.attributes.closed_at,
          project_name: tk.attributes.project_name,
          request_data: tk.attributes.request_data,
          put_to_step_at: tk.attributes.put_to_step_at,
          put_to_step: tk.attributes.put_to_step,
          has_notification: tk.attributes.has_notification,
          ticket_number: tk.attributes.ticket_number,
          position: tk.attributes.position,
          requestSettings: requestSettings,
          generalSettings: generalSettings,
          approval_stage: tk.attributes.approval_stage,
          cron_expression:
            tk.relationships.schedules.data[0]?.attributes.frequency,
          files_number: tk.attributes.files_number,
          comments_number: tk.attributes.comments_number,
          subtasks_number: tk.attributes.subtasks_number,
          incomplete_subtasks_number: tk.attributes.incomplete_subtasks_number,
          is_completed: tk.attributes.is_completed,
          is_closed: tk.attributes.is_closed,
          task_system_id: tk.attributes.task_system_id,
          title: tk.attributes.title,
          description: tk.attributes.description,
          step_id: tk.attributes.step_id,
          owner: tk.attributes.task_user_id,
          is_follow: tk.attributes.is_follow,
          spentTime: tk.attributes.spent_time,
          task_form_data: tk.attributes.task_form_data,
          id: tk.id,
          projectId: tk.relationships.steps.data.attributes.project_id,
          assignees: tk.relationships.assignees.data.map(
            ({ attributes, id }) => {
              return {
                id,
                title: `${attributes.first_name} ${attributes.last_name}`,
                alt: `${attributes.first_name} ${attributes.last_name}`,
                subTitle: attributes.email,
                background: attributes.color,
                phone: attributes.phone,
              };
            }
          ),
          master:
            tk.relationships.master.length === undefined
              ? tk.relationships.master.data[0]
              : null,

        slaves: tk.relationships.slaves.data.map(({ attributes, id }) => {
          return {
            id,
            ...attributes,
          };
        }),

          client_user: tk.attributes.client_user
            ? {
                ...tk.attributes.client_user,
                title: `${tk.attributes.client_user.first_name} ${tk.attributes.client_user.last_name}`,
              }
            : null,
          clients: tk.relationships.clients.data.map(({ attributes, id }) => {
            return {
              id,
              userID: attributes.userID,
              locationId: attributes.locationId,
              title: `${attributes.firstName} ${attributes.lastName}`,
              alt: `${attributes.firstName} ${attributes.lastName}`,
              subTitle: attributes.email,
              phone: attributes.phone,
              background: attributes.color,
              account: attributes.account,
              sub_account_name: attributes.sub_account_name,
            };
          }),
          tags: tk.relationships.tags.data.map((p) => ({
            id: p.id,
            label: p.attributes.label,
            variant: p.attributes.variant,
          })),
          priority: tk.attributes.priority,
          estimated_time: tk.attributes.estimated_time,
          column: {
            ...rest,
            task_count: tasks.data.length,
            index: stepIndex,
          },
          added: tk.attributes.added,
        });

        map_task.resolveAll();
        return map_task;
      });

      const step_built = new Step({
        id: rest.id,
        ids: rest.ids,
        index: stepIndex,
        created_at: rest.created_at,
        updated_at: rest.updated_at,
        name: rest.name,
        position: rest.position,
        project_id: rest.project_id,
        total: rest.total_tasks,
        color: rest.color,
        tasks: tasks_built,
        page: 1,
        canLoad: true,
      });

      return step_built;
    });

    return all;
  }

  run() {
    return this.data;
  }
}

export class QueryLogTimer {
  constructor(params, project) {
    this.data = this.make(params, project);
  }

  make(timers, project) {
    return timers.map((timer, index) => {
      return new LogTimer({
        id: timer.id,
        index,
        createdAt: timer.attributes.created_at,
        updatedAt: timer.attributes.updated_at,
        date: timer.attributes.date,
        timeSpend: timer.attributes.time_spend,
        description: timer.attributes.description,
        user: timer.relationships.users.data,
        isRunning: timer.attributes.is_running,
        startTime: timer.attributes.start_time,
        isClose: timer.attributes.has_been_close,
        top: timer.attributes.position_top,
        left: timer.attributes.position_left,
        taskID: timer.attributes.task_id,
        stepID: timer.attributes.task.step_id,
        project: project,
        exitDateTime: timer.attributes.exit_date_time,
        client: timer.relationships.clients.data,
        task: timer.attributes.task,
        tags: timer.relationships.tags.data.map((tag) => ({
          variant: tag.attributes.variant,
          label: tag.attributes.label,
          id: tag.id,
        })),
      });
    });
  }

  run() {
    return this.data;
  }
}

export class QueryNotifications {
  constructor(params) {
    this.data = this.make(params);
  }

  make(notifications) {
    return notifications?.map((notification) => {
      return new Notification({
        id: notification.id,
        created_at: notification.attributes.created_at,
        has_read: notification.attributes.has_read,
        updated_at: notification.attributes.updated_at,
        models: notification.attributes.models,
        object: notification.attributes.object,
        content: notification.attributes.content,
        isWritable: notification.attributes.owner,

        owner: {
          id: notification.relationships.users.data.id,
          email: notification.relationships.users.data.attributes.email,
          firstName:
            notification.relationships.users.data.attributes.first_name,
          phone: notification.relationships.users.data.attributes.phone,
          lastName: notification.relationships.users.data.attributes.last_name,
          role: notification.relationships.users.data.attributes.role,
          title: `${notification.relationships.users.data.attributes.first_name} ${notification.relationships.users.data.attributes.last_name}`,
          alt: `${notification.relationships.users.data.attributes.first_name} ${notification.relationships.users.data.attributes.last_name}`,
          subTitle: notification.relationships.users.data.attributes.email,
          background: notification.relationships.users.data.attributes.color,
        },

        message: JSON.parse(notification.attributes.message),
      });
    });
  }

  run() {
    return this.data;
  }
}

export class QueryTrigger {
  constructor(params) {
    this.data = this.make(params);
  }

  make(params) {
    try {
      return params.map((trigger) => {
        return new Trigger({
          created_at: trigger.attributes.created_at,
          updated_at: trigger.attributes.updated_at,
          status: trigger.attributes.status,
          title: trigger.attributes.name,
          triggerID: trigger.attributes.trigger_id,
          triggerName: trigger.relationships.triggers.data.attributes.name,
          id: trigger.id,
          tags: trigger.attributes.tags,
          contacts: trigger.attributes.contacts,
          options: trigger.relationships.trigger_options.data,
          custom_field_id: trigger.attributes.custom_field_id,
          default: trigger.attributes.default,
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  run() {
    return this.data;
  }
}

export class QueryTaskForm {
  constructor(params) {
    this.data = this.make(params);
  }

  make(params) {
    return params.map((form) => new TaskForm(form));
  }

  run() {
    return this.data;
  }
}

export class QueryTemplate {
  constructor(params) {
    this.data = this.make(params);
  }

  make(params) {
    return params.map((template) => new Template(template));
  }

  run() {
    return this.data;
  }
}
